<template>
  <!-- <div style="width:100%; min-height:500px; height:auto; overflow-y:auto; overflow-x:hidden;"> -->
  <div style="width:100%; height:auto; overflow-y:auto; overflow-x:hidden;">
    <form ref="refPartnerForm">
      <!-- <div
          id="error"
          class="alert alert-danger"
          role="alert"
          v-if="displayError"
          v-show="errors.items.length"
        >
          <span v-show="errors.has('FirstName')" class="alert-danger">
            {{ errors.first('FirstName') }}
            <br />
          </span>
        </div>
        <div
          ref="refCustomerror"
          id="Customerror"
          class="alert alert-danger"
          role="alert"
          v-show="customerrors.length && !errors.items.length"
        >
          <span v-show="customerrors.length" class="alert-danger">
            <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="error in customerrors" :key="error">{{ error }}</li>
            </ul>
          </span>
      </div>-->
      <div class="form-row" v-if="displayError">
        <div class="form-group col-md-12 section-title-group">
          <label class="section-title">Application Configurations</label>
        </div>
      </div>
      <div class="form-row" v-if="displayError">
        <div class="form-group col-md-6">
          <input
            class="k-checkbox form-control"
            type="checkbox"
            v-model="PartnerInfoFormConfig.parent.ReceiveFMV"
            id="chkFMV"
            :disabled="disabled"
          />
          <label class="k-checkbox-label" for="chkFMV">Receive FMV Statement?</label>
        </div>
        <div class="form-group col-md-6">
          <input
            class="k-checkbox form-control"
            type="checkbox"
            v-model="PartnerInfoFormConfig.parent.VestingAcceleration"
            id="chkVestAcceler"
            :disabled="disabled"
          />
          <label class="k-checkbox-label" for="chkVestAcceler">Vesting Acceleration</label>
        </div>
      </div>

      <br />

      <div class="form-row">
        <!-- <div class="form-group col-md-12 section-title-group">
          <label class="section-title">Partner Details</label> -->
        <div class="col-md-12 section-title-group accordion-pad">
         
          <button class="accordion section-title">Partner Details</button>
          <!-- <label class="section-title">Partner Details</label> -->  
        </div>
      </div>
      <div class="panel">
      <div class="form-row">
        <div class="form-group col-md-6" ref="refPartnerID">
          <label>Partner ID</label>
          <input
            type="text"
            readonly="true"
            v-model="PartnerInfoFormConfig.parent.PartnerID"
            class="form-control"
            placeholder="Partner ID"
            name="PartnerID"
            :disabled="disabled"
          />
        </div>
        <div class="form-group col-md-6">
          <label>Partner Full Name</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.FullName"
            readonly="true"
            class="form-control"
            placeholder="Partner Full Name (Calculated)"
            name="PartnerFullName"
            :disabled="disabled"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label style="display:block">Person Name</label>
          <div class="multi-field multi-field-left col-md-4">
            <input
              @blur="CalculatedFullName"
              name="Prefix"
              type="text"
              v-model="PartnerInfoFormConfig.parent.Prefix"
              class="form-control"
              placeholder="Prefix"
              :disabled="disabled"
            />
          </div>
          <div class="multi-field multi-field-left col-md-4">
            <input
              @blur="CalculatedFullName"
              name="FirstName"
              type="text"
              v-model="PartnerInfoFormConfig.parent.FirstName"
              class="form-control"
              placeholder="First"
              :disabled="disabled"
            />
          </div>
          <div class="multi-field multi-field-right col-md-4">
            <input
              @blur="CalculatedFullName"
              type="text"
              v-model="PartnerInfoFormConfig.parent.MiddleName"
              class="form-control"
              placeholder="Middle"
              :disabled="disabled"
            />
          </div>
        </div>
        <div class="form-group col-md-6">
          <label>Entity Name</label>
          <input
            @blur="CalculatedFullName"
            type="text"
            v-model="PartnerInfoFormConfig.parent.EntityName"
            class="form-control"
            placeholder="Entity Name"
            name="EntityName"
            :disabled="disabled"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <div class="multi-field multi-field-left col-md-6">
            <input
              @blur="CalculatedFullName"
              type="text"
              v-model="PartnerInfoFormConfig.parent.LastName"
              class="form-control"
              placeholder="Last"
              :disabled="disabled"
            />
          </div>
          <div class="multi-field multi-field-right col-md-6">
            <input
              @blur="CalculatedFullName"
              type="text"
              v-model="PartnerInfoFormConfig.parent.Suffix"
              class="form-control"
              placeholder="Suffix"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>T.S. Document ID</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.TSDocId"
            class="form-control"
            placeholder="T.S. Document ID"
            :disabled="disabled"
          />
        </div>
        <div class="form-group col-md-6">
          <label>US Tax ID</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.TaxId"
            class="form-control"
            placeholder="U S Tax ID"
            :disabled="disabled"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label
            v-bind:class="{ 'required-label':this.PartnerInfoFormConfig.parent.PartnerStatus!='Affiliated Partner'&& this.PartnerInfoFormConfig.parent.PartnerStatus!='General Partner' && this.PartnerInfoFormConfig.parent.PartnerStatus!='TS Entity' }"
          >Hire Date</label>
          <div class="input-group">
            <kendo-datepicker
              placeholder="Select Date"
              :value="PartnerInfoFormConfig.parent.HireDate"
              v-model="PartnerInfoFormConfig.parent.HireDate"
              :format="'MM/dd/yyyy'"
              id="dtHireDate"
              width="100%"
              @open="_setCurrentDateifNull"
              :disabled="disabled"
            ></kendo-datepicker>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label>Termination Date</label>
          <div class="input-group">
            <kendo-datepicker
              placeholder="Select Date"
              :value="PartnerInfoFormConfig.parent.LeaveDate"
              v-model="PartnerInfoFormConfig.parent.LeaveDate"
              :format="'MM/dd/yyyy'"
              id="dtLeaveDate"
              width="100%"
              @open="_setCurrentDateifNull"
              :disabled="disabled"
            ></kendo-datepicker>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Employee Type</label>

          <div id="kendo-select">
            <kendo-dropdownlist
              v-model="PartnerInfoFormConfig.parent.PartnerStatus"
              :data-source="dropdownOptions.PartnerStatus"
              :data-text-field="'Option'"
              :option-label="'Select Employee Type'"
              @change="onPartnerStatusChange"
              :data-value-field="'Option'"
              :disabled="disabled"
            ></kendo-dropdownlist>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label>Position</label>
          <div id="kendo-select">
            <kendo-dropdownlist
              v-model="PartnerInfoFormConfig.parent.Position"
              :data-source="dropdownOptions.Position"
              :data-text-field="'Option'"
              :option-label="'Select Position'"
              :data-value-field="'Option'"
              :disabled="disabled"
            ></kendo-dropdownlist>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>US Status</label>
          <div id="kendo-select">
            <kendo-dropdownlist
              v-model="PartnerInfoFormConfig.parent.Domestic"
              :data-source="dropdownOptions.Domestic"
              :data-text-field="'Option'"
              :option-label="'Select US Status'"
              :data-value-field="'Option'"
              :disabled="disabled"
            ></kendo-dropdownlist>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label>Tax Document Delivery Method</label>

          <div id="kendo-select">
            <kendo-dropdownlist
              v-model="PartnerInfoFormConfig.parent.DocumentDeliveryMethod"
              :data-source="dropdownOptions.DocumentDeliveryMethod"
              :data-text-field="'Option'"
              :option-label="'Select Tax Document Delivery Method'"
              :data-value-field="'Option'"
              :disabled="disabled"
            ></kendo-dropdownlist>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Email</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.EMail"
            class="form-control"
            placeholder="Email"
            name="EMail"
            :disabled="disabled"
          />
        </div>
      </div>
      </div>
      <br />

      <div class="form-row">
        <!-- <div class="form-group col-md-12 section-title-group">
          <label class="section-title">Registered Address</label> -->
        <div class="col-md-12 section-title-group accordion-pad">
           <button class="accordion section-title">Registered Address</button>
          <!-- <label class="section-title">Registered Address</label> -->
        </div>
      </div>
      <div class="panel">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Address Line 1</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.Address1"
            class="form-control"
            placeholder="Address Line 1"
            :disabled="disabled"
          />
        </div>
        <div class="form-group col-md-6">
          <label>Address Line 2</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.Address2"
            class="form-control"
            placeholder="Address Line 2"
            :disabled="disabled"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Country</label>
          <div class="input-group mb-3 pl-0">
            <kendo-autocomplete
              id="SearchPartnerCountry"
              class="form-control"
              name="Country"
              v-model="PartnerInfoFormConfig.parent.Country"
              :data-source="CountryAutoCompleteSource"
              :data-text-field="'CountryName'"
              :filter="'contains'"
              :placeholder="'Search for Country'"
              @select="onCountryAutoCompleteSelect"
              @open="onCountryOpen"
              @close="onCountryClose"
              :disabled="disabled"
            ></kendo-autocomplete>
          </div>
        </div>
        <div v-show="StateAutoCompleteSource.length<=0" class="form-group col-md-6">
          <label>State</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.State"
            class="form-control"
            placeholder="State"
            :disabled="disabled"
          />
        </div>
        <div v-show="StateAutoCompleteSource.length>0" class="form-group col-md-6">
          <label>State</label>
          <div class="input-group mb-3 pl-0">
            <kendo-autocomplete
              id="SearchPartnerState"
              class="form-control"
              name="State"
              v-model="PartnerInfoFormConfig.parent.State"
              :data-source="StateAutoCompleteSource"
              :data-text-field="'StateName'"
              :data-value-field="'StateCode'"
              :filter="'contains'"
              :placeholder="'Search for State'"
              @select="onStateAutoCompleteSelect"
              @open="onStateOpen"
              @close="onStateClose"
              :disabled="disabled"
            ></kendo-autocomplete>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>City</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.City"
            class="form-control"
            placeholder="City"
            :disabled="disabled"
          />
        </div>
        <div class="form-group col-md-6">
          <label>Zip Code</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.PostalCode"
            class="form-control"
            placeholder="Zip Code"
            :disabled="disabled"
          />
        </div>
      </div>
</div>
      <br />
      <div class="form-row">
        <!-- <div class="form-group col-md-12 section-title-group">
          <label class="section-title" style="padding-right: 25px;">Mailing Address</label>-->
                  <div class="col-md-12 section-title-group accordion-pad">
          <label class="accordion section-title">Mailing Address</label>
          
        </div>
      </div>
      <div class="panel">
      <div class="form-row">
        <div class="form-group col-md-6">
          <input
            class="k-checkbox"
            type="checkbox"
            @change="handleChange"
            v-model="checkedMailAddress"
            id="chkMailAddress"
            :disabled="disabled"
          />
          <label class="k-checkbox-label" for="chkMailAddress">Same as Registered Address</label>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Address Line 1</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.MailAddress1"
            class="form-control"
            placeholder="Address Line 1"
            :disabled="disabled"
          />
        </div>
        <div class="form-group col-md-6">
          <label>Address Line 2</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.MailAddress2"
            class="form-control"
            placeholder="Address Line 2"
            :disabled="disabled"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Country</label>
          <div class="input-group mb-3 pl-0">
            <kendo-autocomplete
              id="SearchPartnerMailCountry"
              class="form-control"
              name="Country"
              v-model="PartnerInfoFormConfig.parent.MailCountry"
              :data-source="CountryAutoCompleteSource"
              :data-text-field="'CountryName'"
              :filter="'contains'"
              :placeholder="'Search for Country'"
              @select="onMailCountryAutoCompleteSelect"
              @open="onMailCountryOpen"
              @close="onMailCountryClose"
              :disabled="disabled"
            ></kendo-autocomplete>
          </div>
        </div>
        <div v-show="MailStateAutoCompleteSource.length<=0" class="form-group col-md-6">
          <label>State</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.MailState"
            class="form-control"
            placeholder="State"
            :disabled="disabled"
          />
        </div>
        <div v-show="MailStateAutoCompleteSource.length>0" class="form-group col-md-6">
          <label>State</label>
          <div class="input-group mb-3 pl-0">
            <kendo-autocomplete
              id="SearchPartnerMailState"
              class="form-control"
              name="State"
              v-model="PartnerInfoFormConfig.parent.MailState"
              :data-source="MailStateAutoCompleteSource"
              :data-text-field="'StateName'"
              :filter="'contains'"
              :placeholder="'Search for State'"
              @select="onMailStateAutoCompleteSelect"
              @open="onMailStateOpen"
              @close="onMailStateClose"
              :disabled="disabled"
            ></kendo-autocomplete>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>City</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.MailCity"
            class="form-control"
            placeholder="City"
            :disabled="disabled"
          />
        </div>
        <div class="form-group col-md-6">
          <label>Zip Code</label>
          <input
            type="text"
            v-model="PartnerInfoFormConfig.parent.MailPostalCode"
            class="form-control"
            placeholder="Zip Code"
            :disabled="disabled"
          />
        </div>
      </div>
</div>
      <br />
      <div class="form-row">
        <!-- <div class="form-group col-md-12 section-title-group">
          <label class="section-title">Comments/Notes</label> -->
        <div class="col-md-12 section-title-group accordion-pad">
          <label class="accordion section-title">Comments/Notes</label>

        </div>
      </div>
      <div class="panel">
      <div class="form-row">
        <div class="form-group col-md-12">
          <textarea
            class="form-control"
            v-model="PartnerInfoFormConfig.parent.Note"
            placeholder="Add Comments/Notes"
            style=" height: 100%; width: 100%;"
            :disabled="disabled"
          ></textarea>
        </div>
      </div>
      </div>
      <br />
      <div class="form-row">
        <!-- <div class="form-group col-md-12 section-title-group">
          <label class="section-title">Affiliated Partners</label> -->
        <div class="col-md-12 section-title-group accordion-pad">
          <label class="accordion section-title">Affiliated Partners</label>
        </div>
      </div>
      <div class="panel">
      <div class="form-row">
        <div class="form-group col-md-12">
          <BaseGrid
            :mode="'readonly'"
            :config="PartnerAffiliationGridConfig"
            :dropdownOptions="PartnerAffiliationDropDown"
            :data="PartnerInfoFormConfig.children.PartnerAffiliation"
            @DeleteItem="AffiliationDeleteitem"
            @calculatedColumn="SaveInCell"
          ></BaseGrid>
        </div>
      </div>
      </div>
       <div class="form-row">
      <div class="col-md-12 accordion-pad" style="margin-top:10px">
        <label  class="accordion section-title active">Investor Details</label>
      </div>
    </div>
    <div class="panel" style="display:block;">
    <BaseToolBar
      :config="InvestorDetailToolBarConfig"
      @buttonClicked="InvestorToolBarClick"
    ></BaseToolBar>
    <div class="row no-gutters">
      <div class="col-md-12">
        <BaseGrid
          :mode="'readonly'"
          :config="InvestorGridConfig"
          @calculatedColumn="calculatedColumn"
          :data="InvesterData"
        ></BaseGrid>
      </div>
      <!-- {{ProgramInfo}}    -->
    </div>
    </div>      
    </form>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import BaseModal from "@/components/base/BaseModal.vue";
import $ from "jquery";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import { isNullOrUndefined } from "util";
import { mapActions, mapGetters } from "vuex";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelPartnerAffiliation from "@/models/BaseModelPartnerAffiliation.js";
import { PartnerAffiliationGridConfig } from "./PartnerFormConfig.js";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseModelCountries from "@/models/BaseModelCountries.js";
import BaseModelStates from "@/models/BaseModelStates.js";
import {
  InvestorGridConfig,
  InvestorDetailToolBarConfig
} from "@/views/investor/InvestorReportConfig.js";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";

export default {
  name: "InvestorPartnerInfoForm",

  watch: {
    "PartnerInfoFormConfig.parent": function(newVal) {
      //console.log("Inside Watcher")
      if (newVal.Country == "United States of America") {
        this.StateAutoCompleteSource = this.getStateList("USA");
      } else {
        this.StateAutoCompleteSource = [];
      }
      if (newVal.MailCountry == "United States of America") {
        this.MailStateAutoCompleteSource = this.getStateList("USA");
      } else {
        this.MailStateAutoCompleteSource = [];
      }
    }
  },

  props: {
    PartnerInfoFormConfig: {},
    PartnerModalLabel: {},
    InvesterData:{},
    disabled: { default: false }
  },

  mixins: [apiUtil, funcUtil, toolbarUtility],

  components: {
    BaseModal,
    BaseGrid,
    BaseToolBar
  },

  data: function() {
    return {
      displayError: false,
      BaseModelPartner: BaseModelPartner,
      BaseModelPartnerAffiliation: BaseModelPartnerAffiliation,
      BaseModelInputControl: BaseModelInputControl,
      BaseModelCountries: BaseModelCountries,
      BaseModelStates: BaseModelStates,
      InvestorGridConfig: InvestorGridConfig,
      InvestorDetailToolBarConfig: InvestorDetailToolBarConfig,

      PartnerAffiliationGridConfig: PartnerAffiliationGridConfig,
      PartnerAffiliationGridData: [],
      AffiliationDeleteItemsArray: [],

      checkedMailAddress: "",
      customerrors: [],
      dropdownOptions: {
        PartnerStatus: { model: "", dataSource: [] },
        DocumentDeliveryMethod: { model: "", dataSource: [] },
        Domestic: { model: "", dataSource: [] },
        Position: { model: "", dataSource: [] }
      },
      PartnerAffiliationDropDown: {},
      CountryAutoCompleteSource: [],
      StateAutoCompleteSource: [],
      MailStateAutoCompleteSource: [],
      bCountryValid: true,
      bStateValid: true,
      bMailCountryValid: true,
      bMailStateValid: true
    };
  },

  computed: {
    ...mapGetters("getModule", ["withFilter", "getLocalInputControls"]),

    CheckPartnerDetails: function() {
      const self = this;
      var chkError = {
        vldNameorEntity: true,
        vldVestAcc: true,
        vldTermDate: true,
        vldFillTermDate: true,
        mandHireDate: true
      };

      // Entity Name or Partner First, Last, Middle name is required.
      if (
        (isNullOrUndefined(self.PartnerInfoFormConfig.parent.FirstName) ||
          self.PartnerInfoFormConfig.parent.FirstName == "") &&
        (isNullOrUndefined(self.PartnerInfoFormConfig.parent.EntityName) ||
          self.PartnerInfoFormConfig.parent.EntityName == "")
      ) {
        chkError.vldNameorEntity = false;
      }

      // VestingAcceleration is required -- if PartnerStatus is Retired employee
      if (
        self.PartnerInfoFormConfig.parent.PartnerStatus == "Retired Employee" &&
        self.PartnerInfoFormConfig.parent.VestingAcceleration == false
      ) {
        chkError.vldVestAcc = false;
      }

      // Termination date is required if employee type is former or retired employee
      if (
        (self.PartnerInfoFormConfig.parent.PartnerStatus ==
          "Retired Employee" ||
          self.PartnerInfoFormConfig.parent.PartnerStatus ==
            "Former Employee") &&
        !self.PartnerInfoFormConfig.parent.LeaveDate
      ) {
        chkError.vldTermDate = false;
      }

      // If termination date is filled, employee type must be former or retired
      if (
        self.PartnerInfoFormConfig.parent.PartnerStatus != "Retired Employee" &&
        self.PartnerInfoFormConfig.parent.PartnerStatus != "Former Employee" &&
        self.PartnerInfoFormConfig.parent.LeaveDate
      ) {
        chkError.vldFillTermDate = false;
      }

      // Hire Date is mandatory.
      if (
        self.PartnerInfoFormConfig.parent.PartnerStatus !=
          "Affiliated Partner" &&
        self.PartnerInfoFormConfig.parent.PartnerStatus != "General Partner" &&
        self.PartnerInfoFormConfig.parent.PartnerStatus != "TS Entity" &&
        !self.PartnerInfoFormConfig.parent.HireDate
      ) {
        chkError.mandHireDate = false;
      }

      return chkError;
    }
  },

  mounted() {
    const self = this;
    let basemodal = $("#BaseModal");
    $("input:text:visible:first", basemodal).focus();
    self.getInputControls();
    self.getCountryList();
    //self.getStateList();

    //For Displaying List on Focus
    this.ShowAutoCompleteListOnFocus("SearchPartnerCountry");
    this.ShowAutoCompleteListOnFocus("SearchPartnerMailCountry");
    this.ShowAutoCompleteListOnFocus("SearchPartnerState");
    this.ShowAutoCompleteListOnFocus("SearchPartnerMailState");
        var acc = document.getElementsByClassName("accordion");
    let i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function(e) {
    e.preventDefault();
    this.classList.toggle("active");
    var panel = $(this).parent().parent().next(".panel")[0];
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }

    $(this).parent().parent().prevAll(".panel").css("display", "none");
    $(this).parent().parent().prevAll().find(".accordion").removeClass('active');
    $(this).parent().parent().next().nextAll(".panel").css("display", "none");
    $(this).parent().parent().next().nextAll().find(".accordion").removeClass('active');
  });
}
  },

  methods: {
    ...mapActions("postModule", [
      "CreateAllItems",
      "deleteAllItem",
      "UpdateAllItems",
      "CreateJoinedItems"
    ]),

    SaveInCell: function(e) {
      const self = this;

      self.PartnerAffiliationGridData = self.GetCurrentAffiliationGridData(e);
    },

    GetCurrentAffiliationGridData(e) {
      const self = this;
      const gview = $("#" + self.PartnerAffiliationGridConfig.grid.gridId).data(
        "kendoGrid"
      );

      if (e) {
        var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

        // Note PartnerId is fetched using Partner Name
        let result = this.withFilter(self.BaseModelPartner.list, "");

        let filterPartnerAPIData = _.filter(result, function(obj) {
          return obj.FullName == e.values.AffiliatedPartnerFullName;
        });

        if (filterPartnerAPIData.length) {
          e.model.AffiliatedPartnerId = filterPartnerAPIData[0].Id;
          e.model.AffiliatedPartnerID = filterPartnerAPIData[0].PartnerID;
          e.model.PartnerId = self.PartnerInfoFormConfig.parent.Id;

          var AffiliatedPartnerID = e.container
            .closest("TR")
            .find(".AffiliatedPartnerID");
          AffiliatedPartnerID.html(filterPartnerAPIData[0].PartnerID);
        }
      }

      let gridArray = [];
      var gridData = gview.dataSource.data();
      for (let i = 0; i < gridData.length; i++) {
        let element = gridData[i];
        gridArray.push(element);
      }
      return gridArray;
    },

    AffiliationDeleteitem: function(e) {
      const self = this;
      e.preventDefault();
      var gview = $("#" + self.PartnerAffiliationGridConfig.grid.gridId).data(
        "kendoGrid"
      );
      const message = "Are you sure you want to delete this record?";
      self._ConfirmationPopup(message, "DELETE").then(result => {
        if (result.value) {
          var dataItem = gview.dataItem(
            window.$(e.currentTarget).closest("tr")
          );
          if (
            dataItem.Id != 0 &&
            dataItem.Id != null &&
            dataItem.Id != undefined
          ) {
            self.AffiliationDeleteItemsArray.push({ Id: dataItem.Id });
          }
          var row = gview.tbody.find("tr[data-uid='" + dataItem.uid + "']");
          gview.removeRow(row);
        }
      });
    },

    onPartnerStatusChange() {
      const self = this;
      // If employee type is not retired employee, vesting acceleration is not editable and should be unchecked
      let chkBoxVestingAcc = $("#chkVestAcceler");
      if (
        self.PartnerInfoFormConfig.parent.PartnerStatus != "Retired Employee"
      ) {
        chkBoxVestingAcc[0].checked = false;
        chkBoxVestingAcc[0].disabled = true;
      } else {
        chkBoxVestingAcc[0].checked =
          self.PartnerInfoFormConfig.parent.VestingAcceleration == "Yes"
            ? true
            : false;
        chkBoxVestingAcc[0].disabled = false;
      }
    },

    CalculatedFullName: function() {
      const self = this;
      let editCalFullName = "";

      if (self.PartnerModalLabel.modalAddorEdit == "Edit") {
        if (
          !isNullOrUndefined(self.PartnerInfoFormConfig.parent.EntityName) &&
          self.PartnerInfoFormConfig.parent.EntityName != ""
        ) {
          editCalFullName = self.PartnerInfoFormConfig.parent.EntityName;
        } else {
          if (!isNullOrUndefined(self.PartnerInfoFormConfig.parent.Prefix)) {
            editCalFullName = self.PartnerInfoFormConfig.parent.Prefix;
          }
          if (!isNullOrUndefined(self.PartnerInfoFormConfig.parent.FirstName)) {
            editCalFullName +=
              " " + self.PartnerInfoFormConfig.parent.FirstName;
          }
          if (
            !isNullOrUndefined(self.PartnerInfoFormConfig.parent.MiddleName)
          ) {
            editCalFullName +=
              " " + self.PartnerInfoFormConfig.parent.MiddleName;
          }
          if (!isNullOrUndefined(self.PartnerInfoFormConfig.parent.LastName)) {
            editCalFullName += " " + self.PartnerInfoFormConfig.parent.LastName;
          }
          if (!isNullOrUndefined(self.PartnerInfoFormConfig.parent.Suffix)) {
            editCalFullName += " " + self.PartnerInfoFormConfig.parent.Suffix;
          }
        }
        self.PartnerInfoFormConfig.parent.FullName = editCalFullName;
      } else {
        if (
          !isNullOrUndefined(self.PartnerInfoFormConfig.parent.EntityName) &&
          self.PartnerInfoFormConfig.parent.EntityName != ""
        ) {
          self.PartnerInfoFormConfig.parent.FullName =
            self.PartnerInfoFormConfig.parent.EntityName;
        } else {
          if (!isNullOrUndefined(self.PartnerInfoFormConfig.parent.Prefix)) {
            self.PartnerInfoFormConfig.parent.FullName =
              self.PartnerInfoFormConfig.parent.Prefix;
          }
          if (!isNullOrUndefined(self.PartnerInfoFormConfig.parent.FirstName)) {
            self.PartnerInfoFormConfig.parent.FullName +=
              " " + self.PartnerInfoFormConfig.parent.FirstName;
          }
          if (
            !isNullOrUndefined(self.PartnerInfoFormConfig.parent.MiddleName)
          ) {
            self.PartnerInfoFormConfig.parent.FullName +=
              " " + self.PartnerInfoFormConfig.parent.MiddleName;
          }
          if (!isNullOrUndefined(self.PartnerInfoFormConfig.parent.LastName)) {
            self.PartnerInfoFormConfig.parent.FullName +=
              " " + self.PartnerInfoFormConfig.parent.LastName;
          }
          if (!isNullOrUndefined(self.PartnerInfoFormConfig.parent.Suffix)) {
            self.PartnerInfoFormConfig.parent.FullName +=
              " " + self.PartnerInfoFormConfig.parent.Suffix;
          }
        }
      }
    },

    validatePartnerDetail: function() {
      const self = this;
      self.customerrors = [];
      let form = self.PartnerInfoFormConfig.parent;

      if (!self.CheckPartnerDetails.vldNameorEntity) {
        self.customerrors.push("The Person Name or Entity Name is required.");
      }

      if (!self.CheckPartnerDetails.vldVestAcc) {
        self.customerrors.push("The Vesting Acceleration is required.");
      }

      if (!self.CheckPartnerDetails.vldTermDate) {
        self.customerrors.push("The Termination Date is required.");
      }

      if (!self.CheckPartnerDetails.mandHireDate) {
        self.customerrors.push("The Hire Date is required.");
      }

      if (!self.CheckPartnerDetails.vldFillTermDate) {
        self.customerrors.push(
          "Termination Date is filled. Employee Type should be Former or Retired Employee!"
        );
      }
      if (
        !self.bCountryValid &&
        !isNullOrUndefined(self.PartnerInfoFormConfig.parent.Country)
      ) {
        self.customerrors.push("Registered Address Country is Invalid");
      }
      if (
        !self.bStateValid &&
        !isNullOrUndefined(self.PartnerInfoFormConfig.parent.State) &&
        self.StateAutoCompleteSource.length > 0
      ) {
        self.customerrors.push("Registered Address State is Invalid");
      }
      if (
        !self.bMailCountryValid &&
        !isNullOrUndefined(self.PartnerInfoFormConfig.parent.MailCountry)
      ) {
        self.customerrors.push("Mailing Address Country is Invalid");
      }
      if (
        !self.bMailStateValid &&
        !isNullOrUndefined(self.PartnerInfoFormConfig.parent.MailState) &&
        self.MailStateAutoCompleteSource.length > 0
      ) {
        self.customerrors.push("Mailing Address State is Invalid");
      }
      //Special Char Validations
      if (form.FullName != null || form.FullName != undefined) {
        if (self._validateSpecialCharacter(form.FullName, "singleline")) {
          self.customerrors.push(
            `The Person Name or Entity Name cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      if (form.TSDocId != null || form.TSDocId != undefined) {
        if (self._validateSpecialCharacter(form.TSDocId, "singleline")) {
          self.customerrors.push(
            `T.S. Document ID cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      if (form.TaxId != null || form.TaxId != undefined) {
        if (self._validateSpecialCharacter(form.TaxId, "singleline")) {
          self.customerrors.push(
            `US Tax ID cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      //Special Char Validations
      if (form.FullName != null || form.FullName != undefined) {
        if (
          self._validateSpecialCharacter(
            form.FullName.replace(/"/g, "").replace(/'/g, ""),
            "singleline"
          )
        ) {
          self.customerrors.push(
            `The Person Name or Entity Name cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      if (form.TSDocId != null || form.TSDocId != undefined) {
        if (
          self._validateSpecialCharacter(
            form.TSDocId.replace(/"/g, "").replace(/'/g, ""),
            "singleline"
          )
        ) {
          self.customerrors.push(
            `T.S. Document ID cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      if (form.TaxId != null || form.TaxId != undefined) {
        if (
          self._validateSpecialCharacter(
            form.TaxId.replace(/"/g, "").replace(/'/g, ""),
            "singleline"
          )
        ) {
          self.customerrors.push(
            `US Tax ID cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      if (form.EMail != null || form.EMail != undefined) {
        if (
          !(form.EMail == "" || isNullOrUndefined(form.EMail)) &&
          !self._validateSpecialCharacter(form.EMail, "email")
        ) {
          self.customerrors.push(`Email address is Invalid.`);
        }
      }
      if (form.Address1 != null || form.Address1 != undefined) {
        if (
          self._validateSpecialCharacter(
            form.Address1.replace(/"/g, "").replace(/'/g, ""),
            "multiline"
          )
        ) {
          self.customerrors.push(
            `Registered Address : Address Line 1 cannot have ${this.MultiLineSpecialChars}  Characters`
          );
        }
      }
      if (form.Address2 != null || form.Address2 != undefined) {
        if (
          self._validateSpecialCharacter(
            form.Address2.replace(/"/g, "").replace(/'/g, ""),
            "multiline"
          )
        ) {
          self.customerrors.push(
            `Registered Address : Address Line 2 cannot have ${this.MultiLineSpecialChars}  Characters`
          );
        }
      }
      if (form.City != null || form.City != undefined) {
        if (
          self._validateSpecialCharacter(
            form.City.replace(/"/g, "").replace(/'/g, ""),
            "singleline"
          )
        ) {
          self.customerrors.push(
            `Registered Address : City cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      if (form.State != null || form.State != undefined) {
        if (
          self._validateSpecialCharacter(
            form.State.replace(/"/g, "").replace(/'/g, ""),
            "singleline"
          )
        ) {
          self.customerrors.push(
            `Registered Address : State cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      if (form.PostalCode != null || form.PostalCode != undefined) {
        if (self._validateSpecialCharacter(form.PostalCode, "singleline")) {
          self.customerrors.push(
            `Registered Address : PostalCode cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      if (form.MailAddress1 != null || form.MailAddress1 != undefined) {
        if (
          self._validateSpecialCharacter(
            form.MailAddress1.replace(/"/g, "").replace(/'/g, ""),
            "multiline"
          )
        ) {
          self.customerrors.push(
            `Mailing Address : Address Line 1 cannot have ${this.MultiLineSpecialChars}  Characters`
          );
        }
      }
      if (form.MailAddress2 != null || form.MailAddress2 != undefined) {
        if (
          self._validateSpecialCharacter(
            form.MailAddress2.replace(/"/g, "").replace(/'/g, ""),
            "multiline"
          )
        ) {
          self.customerrors.push(
            `Mailing Address : Address Line 2 cannot have ${this.MultiLineSpecialChars}  Characters`
          );
        }
      }
      if (form.MailCity != null || form.MailCity != undefined) {
        if (
          self._validateSpecialCharacter(
            form.MailCity.replace(/"/g, "").replace(/'/g, ""),
            "singleline"
          )
        ) {
          self.customerrors.push(
            `Mailing Address : City cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      if (form.MailState != null || form.MailState != undefined) {
        if (
          self._validateSpecialCharacter(
            form.MailState.replace(/"/g, "").replace(/'/g, ""),
            "singleline"
          )
        ) {
          self.customerrors.push(
            `Mailing Address : State cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      if (form.MailPostalCode != null || form.MailPostalCode != undefined) {
        if (self._validateSpecialCharacter(form.MailPostalCode, "singleline")) {
          self.customerrors.push(
            `Mailing Address : PostalCode cannot have ${this.SingleLineSpecialChars}  Characters`
          );
        }
      }
      if (form.Note != null || form.Note != undefined) {
        if (
          self._validateSpecialCharacter(
            form.Note.replace(/"/g, "").replace(/'/g, ""),
            "multiline"
          )
        ) {
          self.customerrors.push(
            `Comments/Notes cannot have ${this.MultiLineSpecialChars}  Characters`
          );
        }
      }

      if (!self.customerrors.length) {
        return true;
      }
    },

    // Mailing address same as Residing address
    handleChange: function() {
      if (this.checkedMailAddress) {
        this.PartnerInfoFormConfig.parent.MailAddress1 = this.PartnerInfoFormConfig.parent.Address1;
        this.PartnerInfoFormConfig.parent.MailAddress2 = this.PartnerInfoFormConfig.parent.Address2;
        this.PartnerInfoFormConfig.parent.MailCity = this.PartnerInfoFormConfig.parent.City;
        this.PartnerInfoFormConfig.parent.MailState = this.PartnerInfoFormConfig.parent.State;
        this.PartnerInfoFormConfig.parent.MailPostalCode = this.PartnerInfoFormConfig.parent.PostalCode;
        this.PartnerInfoFormConfig.parent.MailCountry = this.PartnerInfoFormConfig.parent.Country;
      } else {
        this.PartnerInfoFormConfig.parent.MailAddress1 = "";
        this.PartnerInfoFormConfig.parent.MailAddress2 = "";
        this.PartnerInfoFormConfig.parent.MailCity = "";
        this.PartnerInfoFormConfig.parent.MailState = "";
        this.PartnerInfoFormConfig.parent.MailPostalCode = "";
        this.PartnerInfoFormConfig.parent.MailCountry = "";
      }
    },

    // save Partner data
    async saveChanges() {
      const self = this;
      self.displayError = true;

      //Read current data from the Grid
      self.PartnerInfoFormConfig.children.PartnerAffiliation = self.GetCurrentAffiliationGridData(
        null
      );

      // self.$validator.validate().then(result => {
      if (self.validatePartnerDetail()) {
        if (self.PartnerModalLabel.modalAddorEdit == "Add") {
          console.log(JSON.stringify(self.PartnerInfoFormConfig));

          self.PartnerInfoFormConfig.parent.ReceiveFMV = self
            .PartnerInfoFormConfig.parent.ReceiveFMV
            ? "Yes"
            : "No";
          self.PartnerInfoFormConfig.parent.VestingAcceleration = self
            .PartnerInfoFormConfig.parent.VestingAcceleration
            ? "Yes"
            : "No";

          // US #1178 : Partner ID
          const result = this.withFilter(self.BaseModelPartner.list, "");

          if (result.length <= 0) {
            self.PartnerInfoFormConfig.parent.PartnerID = 100001;
          } else {
            //let lastElement = _.last(result);
            self.PartnerInfoFormConfig.parent.PartnerID = self._getIncrementalID(
              result,
              "PartnerID"
            );
          }

          if (self.PartnerInfoFormConfig.parent.LeaveDate == "") {
            delete self.PartnerInfoFormConfig.parent.LeaveDate;
          }
          if (self.PartnerInfoFormConfig.parent.HireDate == "") {
            delete self.PartnerInfoFormConfig.parent.HireDate;
          }

          var addFormValues = {
            parent: self.PartnerInfoFormConfig.parent,
            children: {
              PartnerAffiliation: self.PartnerAffiliationGridData
            }
          };

          let joinedItems = {
            joinedObject: {
              parentConfig: self.BaseModelPartner,
              childConfigs: [self.BaseModelPartnerAffiliation]
            },
            createData: addFormValues,
            ParentKey: "PartnerId"
          };
          console.log(JSON.stringify(self.PartnerInfoFormConfig));

          //let loader = this.$loading.show();
          this._APICrudPopup("APICrudpopup");
          this.CreateJoinedItems(joinedItems)
            .then(response => {
              //refresh the grid data only after the update gets completed
              self.$emit("SaveComplete");
              this._AlertPopup("Data Saved Successfully!", "success");
            })
            .catch(error => {
              this._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });
        } else {
          console.log(JSON.stringify(self.PartnerInfoFormConfig));

          var editForm = self.PartnerInfoFormConfig.parent;

          self.PartnerInfoFormConfig.parent.ReceiveFMV = self
            .PartnerInfoFormConfig.parent.ReceiveFMV
            ? "Yes"
            : "No";
          self.PartnerInfoFormConfig.parent.VestingAcceleration = self
            .PartnerInfoFormConfig.parent.VestingAcceleration
            ? "Yes"
            : "No";

          var editFormAffiliatePartner =
            self.PartnerInfoFormConfig.children.PartnerAffiliation;

          var editFormArray = [];
          editFormArray.push(editForm);

          //let loader = this.$loading.show();
          self._APICrudPopup("APICrudpopup");

          //Deleted Affiliated Partner items in edit form
          let deletedobject = null;
          if (self.AffiliationDeleteItemsArray.length > 0) {
            deletedobject = {
              PartnerAffiliation: {
                config: BaseModelPartnerAffiliation,
                deleteData: self.AffiliationDeleteItemsArray
              }
            };
          }

          if (deletedobject != null) {
            let deleteResponse = await this.deleteAllItem(deletedobject);
          }

          //added Affiliated Partner items in edit form
          let addedAffiliatedPartnerArray = [];
          addedAffiliatedPartnerArray = self.getaddeditems(
            editFormAffiliatePartner
          );
          addedAffiliatedPartnerArray.forEach(element => {
            element.PartnerId = editForm.Id;
          });

          //using Create All method for newly added Affiliated Partner
          let createdobject = null;
          if (addedAffiliatedPartnerArray.length > 0) {
            createdobject = {
              PartnerAffiliation: {
                config: BaseModelPartnerAffiliation,
                createData: addedAffiliatedPartnerArray
              }
            };
          }

          if (createdobject != null) {
            let createResponse = await this.CreateAllItems(createdobject);
          }

          //Remove added items from update JSON
          editFormAffiliatePartner = self.removeAddedItemsforUpdate(
            editFormAffiliatePartner
          );

          //Update Affiliated Partner items in edit form
          var updateobject = {
            Partner: {
              config: self.BaseModelPartner,
              updateData: editFormArray
            },
            PartnerAffiliation: {
              config: self.BaseModelPartnerAffiliation,
              updateData: editFormAffiliatePartner
            }
          };

          this.UpdateAllItems(updateobject)
            .then(res => {
              //refresh the grid data only after the update gets completed
              self.$emit("SaveComplete");
              //loader.hide();
              self._AlertPopup("Data Saved Successfully!", "success");
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });
        }

        $("#BaseModal").modal("toggle");
        self.resetFields();
      } else {
        let basemodal = $("#BaseModal");
        $("input:checkbox:visible:first", basemodal).focus();
      }
      // });
    },

    removeAddedItemsforUpdate: function(objdata) {
      let filteredData = objdata.filter(function(e) {
        return e["Id"] != 0 && e["Id"] != null && e["Id"] != undefined;
      });
      return filteredData;
    },

    getaddeditems: function(objdata) {
      let filteredData = objdata.filter(function(e) {
        return e["Id"] == 0 || e["Id"] == null || e["Id"] == undefined;
      });
      return filteredData;
    },

    // reset the form fields
    resetFields: function() {
      const self = this;
      self.displayError = false;
      // self.$refs.refPartnerForm.reset();
      self.errors.clear();
      //Object.assign(self.$data, self.$options.data.call(self));
      self.customerrors = [];
    },

    getInputControls() {
      let basemodal = $("#BaseModal");
      $("input:text:visible:first", basemodal).focus();

      const self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );

      self.dropdownOptions["DocumentDeliveryMethod"] =
        response["DocumentDeliveryMethod"];
      self.dropdownOptions["PartnerStatus"] = response["PartnerStatus"];
      self.dropdownOptions["Domestic"] = response["Domestic"];
      self.dropdownOptions["Position"] = response["Position"];

      self.getPartnerForAffiliation();
    },

    getPartnerForAffiliation() {
      const self = this;

      // US #1214 : Partner Information Page - Hide Treasury Units
      let result = this.withFilter(self.BaseModelPartner.list, "");

      let filterPartnerAPIData = _.filter(result, function(obj) {
        return (
          obj.FullName != "Treasury Units" &&
          obj.PartnerStatus == "Affiliated Partner"
        );
      });

      var partnerData = [];
      if (filterPartnerAPIData.length) {
        filterPartnerAPIData.forEach(item => {
          let obj = {};
          obj.Id = item.Id;
          obj.Option = item.FullName;
          partnerData.push(obj);
        });
      }

      if (partnerData.length) {
        self.PartnerAffiliationDropDown.AffiliatedPartnerFullName = _.sortBy(
          partnerData,
          [
            function(o) {
              return o.Option.toLowerCase();
            }
          ]
        );
      }
    },

    getCountryList() {
      let countriesArray = this.withFilter(BaseModelCountries.list, "");
      let index = countriesArray.findIndex(o => o.CountryCode == "USA");
      if (index && index >= 0) {
        let country = countriesArray[index];
        countriesArray.splice(index, 1);
        countriesArray.unshift(country);
      }
      this.CountryAutoCompleteSource = countriesArray;
    },

    getStateList(countryCode) {
      if (isNullOrUndefined(countryCode)) {
        this.StateAutoCompleteSource = this.withFilter(
          BaseModelStates.list,
          ""
        );
        this.MailStateAutoCompleteSource = this.withFilter(
          BaseModelStates.list,
          ""
        );
      }
      return this.withFilter(BaseModelStates.list, {
        filter: "CountryCode eq '" + countryCode + "'"
      });
    },

    onCountryAutoCompleteSelect(e) {
      this.bCountryValid = true;
      this.autocompleteValue = e.dataItem.CountryName;
      this.PartnerInfoFormConfig.parent.Country = e.dataItem.CountryName;
      this.PartnerInfoFormConfig.parent.State = null;
      this.StateAutoCompleteSource = this.getStateList(e.dataItem.CountryCode);
      this.ShowAutoCompleteListOnFocus("SearchPartnerState");
    },

    onCountryOpen() {
      this.bCountryValid = false;
    },

    onCountryClose() {
      if (!this.bCountryValid) {
        this.PartnerInfoFormConfig.parent.Country = null;
      }
    },

    onMailCountryAutoCompleteSelect(e) {
      this.bMailCountryValid = true;
      this.autocompleteValue = e.dataItem.CountryName;
      this.PartnerInfoFormConfig.parent.MailCountry = e.dataItem.CountryName;
      this.PartnerInfoFormConfig.parent.MailState = null;
      this.MailStateAutoCompleteSource = this.getStateList(
        e.dataItem.CountryCode
      );
      this.ShowAutoCompleteListOnFocus("SearchPartnerMailState");
    },

    onMailCountryOpen() {
      this.bMailCountryValid = false;
    },

    onMailCountryClose() {
      if (!this.bMailCountryValid) {
        this.PartnerInfoFormConfig.parent.MailCountry = null;
      }
    },

    onStateAutoCompleteSelect(e) {
      this.bStateValid = true;
      //this.autocompleteValue = e.dataItem.StateCode;
      this.PartnerInfoFormConfig.parent.State = e.dataItem.StateCode;
    },

    onStateOpen() {
      this.bStateValid = false;
    },

    onStateClose() {
      if (!this.bStateValid) {
        this.PartnerInfoFormConfig.parent.State = null;
      }
    },

    onMailStateAutoCompleteSelect(e) {
      this.bMailStateValid = true;
      this.autocompleteValue = e.dataItem.StateCode;
      this.PartnerInfoFormConfig.parent.MailState = e.dataItem.StateCode;
    },

    onMailStateOpen() {
      this.bMailStateValid = false;
    },

    onMailStateClose() {
      if (!this.bMailStateValid) {
        this.PartnerInfoFormConfig.parent.MailState = null;
      }
          },
     calculatedColumn: function(e) {
      if (e.values.hasOwnProperty("UnitsToBeRetained")) {
        if (
          e.values.UnitsToBeRetained <=
          e.model.AwardedUnits - e.model.VestedUnits
        ) {
          //After UnitsToBeReatined edit- search in grid --Start
          let i = e.sender._data.findIndex(obj => {
            return obj.uid == e.model.uid && obj.Id == e.model.Id;
          });
          console.log("rerset", i);

          //After UnitsToBeReatined edit- search in grid --End

          //Total Units to be retained
          var TotalUnitsToBeRetained = e.container
            .closest("TR")
            .find(".TotalUnitsToBeRetained");
          let calcTotalUnitsToBeRetained =
            e.values.UnitsToBeRetained + e.model.VestedUnits;
          TotalUnitsToBeRetained.html(calcTotalUnitsToBeRetained);
          e.sender._data[i].TotalUnitsToBeRetained = calcTotalUnitsToBeRetained;

          //Units To Be Forfeited
          var UnitsToBeForfeited = e.container
            .closest("TR")
            .find(".UnitsToBeForfeited");
          let calcUnitsToBeForfeited =
            e.model.AwardedUnits - calcTotalUnitsToBeRetained;
          UnitsToBeForfeited.html(calcUnitsToBeForfeited);
          e.sender._data[i].UnitsToBeForfeited = calcUnitsToBeForfeited;

          //Amount Payable
          var AmountPayable = e.container.closest("TR").find(".AmountPayable");
          let calcAmountPayable =
            e.model.UnitPrice * calcTotalUnitsToBeRetained;
          calcAmountPayable = isNaN(parseInt(calcAmountPayable))
            ? 0
            : parseInt(calcAmountPayable);
          AmountPayable.html(calcAmountPayable);
          e.sender._data[i].AmountPayable = calcAmountPayable;

          //Amount Receivable
          var AmountReceivable = e.container
            .closest("TR")
            .find(".AmountReceivable");
          let calcAmountReceivable = e.model.UnitPrice * calcUnitsToBeForfeited;
          calcAmountReceivable = isNaN(parseInt(calcAmountReceivable))
            ? 0
            : parseInt(calcAmountReceivable);
          AmountReceivable.html(calcAmountReceivable);
          e.sender._data[i].AmountReceivable = calcAmountReceivable;

          //Amount Paid (or) Paid for Units
          var AmountPaid = e.container.closest("TR").find(".AmountPaid");
          let calcAmountPaid =
            e.model.AmountPaidForProgram *
            (e.model.AwardedUnits / e.model.SumofAwardedUnits);
          AmountPaid.html(calcAmountPaid);
          e.sender._data[i].AmountPaid = calcAmountPaid;

          //Buyout
          var Buyout = e.container.closest("TR").find(".Buyout");
          let calcBuyout =
            calcAmountPaid - calcAmountPayable > 0
              ? calcAmountPaid - calcAmountPayable
              : 0;
          Buyout.html(calcBuyout); // have to update with AmountPaid variable
          e.sender._data[i].Buyout = calcBuyout;

          //Amount owed to partnership
          var AmountOwedToPartnership = e.container
            .closest("TR")
            .find(".AmountOwedToPartnership");
          let calcAmountOwedToPartnership =
            calcAmountPayable - calcAmountPaid > 0
              ? calcAmountPayable - calcAmountPaid
              : 0;
          AmountOwedToPartnership.html(calcAmountOwedToPartnership); // have to update with AmountPaid variable
          e.sender._data[
            i
          ].AmountOwedToPartnership = calcAmountOwedToPartnership;

          //Contribution relief
          var ContributionRelief = e.container
            .closest("TR")
            .find(".ContributionRelief");
          let calcContributionRelief = calcAmountReceivable - calcBuyout;
          ContributionRelief.html(calcContributionRelief);
          e.sender._data[i].ContributionRelief = calcContributionRelief;

          //Net payout
          var NetPayout = e.container.closest("TR").find(".NetPayout");
          let calcNetPayout = calcBuyout - calcAmountOwedToPartnership;
          NetPayout.html(calcNetPayout);
          e.sender._data[i].NetPayout = calcNetPayout;
        } else {
          this._AlertPopup(
            "Please enter valid data in UnitstobeRetained Column. Eg: (Units to be Retained should be Greaterthan or equal to Zero and Units to be Retained should be lesserthan or equal to the difference of AwardedUnits and VestedUnits)",
            "warning"
          );
        }
      }
    },

     InvestorToolBarClick(e) {
      switch (e.id) {
        case "detailView": {
          this._displayGridColumns("investorReportDetailGrid", {
            Issuance: "show",
            Transfer: "show",
            Forfeiture: "show",
          });
           if(this.InvestorInfo.every(x => x.Forfeiture === 0)) {
               var grid = $("#investorReportDetailGrid").data("kendoGrid"); 
               grid.hideColumn("Forfeiture");
           }
            break;
          }
        case "summaryView":
          this._displayGridColumns("investorReportDetailGrid", {
            Issuance: "hide",
            Transfer: "hide",
            Forfeiture: "hide"
          });
          break;
        default:
          break;
        }
      this._baseToolBarEvents("investorReportDetailGrid", ...arguments);
    }
  }
};
</script>


<style>
.accordion-pad{
  padding:0 ;
}
.accordion {
  background-color: #eee;
  cursor: pointer;
  padding: 10px 10px 9px 10px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 16px;
  font-weight: bold;
  color: #4A4A4A;
  transition: 0.4s;
}

 .active,.accordion:hover {
  background-color: #ccc;
}

.accordion:after {
  content: '\002B';
  color: #777;
  font-size:25px;
  font-weight: bold;
  float: right;
  margin-right:5px;
  margin-top:-8px;
}

.panel {
  margin-top:15px;
  background-color: white;
  overflow: hidden;
  display:none;
  transition: max-height 0.2s ease-out;
}

.active:after {
  content: "\2212";
}
</style>



